import {
  ACTIVE_RISKS_SUBTEXT,
  ACTIVE_RISKS_TITLE,
  type ActiveRisksCount,
  isActiveRisksCountNumber,
  isActiveRisksCountUnavailable,
} from "@/features/risks/activeRisksCount";

/**
 * Portfolio / program rollup card for `totals.activeRisksCount`.
 * Number (including 0) renders the count; `{ status: "unavailable" }` → Unavailable.
 * Never hide the card — absence of a number must not read as "no risks".
 */
export function ActiveRisksCountCard({
  count,
}: {
  count: ActiveRisksCount | null | undefined;
}) {
  if (
    count == null ||
    isActiveRisksCountUnavailable(count) ||
    !isActiveRisksCountNumber(count)
  ) {
    return (
      <div
        className="p-4 border rounded-lg border-slate-300 border-dashed bg-slate-50"
        data-testid="active-risks-count-unavailable"
      >
        <div className="text-sm text-gray-600 mb-1">{ACTIVE_RISKS_TITLE}</div>
        <div className="text-base font-semibold text-slate-500">Unavailable</div>
        <div className="text-[11px] leading-tight text-slate-500 mt-1">
          {ACTIVE_RISKS_SUBTEXT}
        </div>
      </div>
    );
  }

  return (
    <div
      className="p-4 border rounded-lg border-gray-200 bg-white"
      data-testid="active-risks-count-card"
    >
      <div className="text-sm text-gray-600 mb-1">{ACTIVE_RISKS_TITLE}</div>
      <div className="text-2xl font-semibold text-gray-900">{count}</div>
      <div className="text-[11px] leading-tight text-slate-500 mt-1">
        {ACTIVE_RISKS_SUBTEXT}
      </div>
    </div>
  );
}
